import { getChapterTitle, type Chapter } from "@repo/app-types/entities/course";
import { TooltipArrow } from "@repo/ui/tooltip/arrow";
import { tooltipStyle } from "@repo/ui/tooltip/style";
import type { FC, ReactNode } from "react";
import { Tooltip } from "react-aria-components";

export interface ChapterTooltipProps {
  chapterIndex: number;
  chapter: Chapter;
  children?: ReactNode;
}

export const ChapterTooltip: FC<ChapterTooltipProps> = (props) => {
  const { chapterIndex, chapter, children } = props;

  return (
    <Tooltip className={tooltipStyle().tooltip()}>
      <TooltipArrow />

      <div className="max-w-xs px-2.5 py-2 text-xs leading-5">
        <div className="truncate text-sm font-semibold">
          {getChapterTitle(chapterIndex, chapter)}
        </div>

        {children}
      </div>
    </Tooltip>
  );
};
